import { actionsLoadingTemplate, actionsNormalTemplate } from '../../utils/actionsTemplate.js';
import { insuRestApi, RestApi, RouterRepository } from '@/services/restApi.js';
import CryptoJS from 'crypto-es';

const state = {
    payload: {
        reg: {
            userCi: '', //사용자 CI 값*
            userNm: '', //사용자명*
            birthday: '', //생년월일(yyyyMMdd)*
            sex: '', //성별*
            userIdno2: '', //주민번호뒷자리*
            termsIds: [], //약관동의번호*
            optTerms: [], //선택약관 추가 //optTermsId:'',optTermsValue:''
            userTel: '', //휴대전화번호*
            userEmail: '', //이메일*(농협생명 청구 시 필수값)
            userPostNo: '', //우편번호(도로명)*
            userAddr: '', //주소(도로명)*
            userAddrDetail: '', //주소상세(도로명)*
            hospitalCd: '00000000', //병원 코드*
            multiSubscrib: [], // 다건 구독 시 필요한 병원정보
            jobCd: '', //직업코드
            jobNm: '', //직업명*
            minAmt: '', //진료비설정금액*
            signImg: '', //서명이미지*
            idcardImg: '', //신분증사진
            idcardType: '', //신분증종류
            idcardIssueDate: '', //신분증 발급일자
            idcardIssueOrg: '', //신분증 발급기관명
            regNo: '', //등록번호 (면허증번호 또는 외국인등록번호)
            checkCd: '', //면허증 일련번호
            postCenter: '', //우체국지역센터
            applyChannel: '', //자동청구채널유형(병원:HOSPITAL/외부기관:COMPANY)*
            applyOrg: '', //자동청구기관(병원코드)*
            insuCompCd: '', //보험사코드*
            agreeIds: '', //보험사 청구동의 선택*
            bankCd: '', //금융기관코드*
            bankAccount: '', //계좌번호*
            bankAccountHolder: '', //예금주*
            bankAccountRel: '', //예금주와의 관계*(메리츠 청구 시 필수값)
            goodsSubsId: '', //구독상품id*
            subsStatus: '', //구독상태
            contractStartDate: '', //약정시작일
            contractEndDate: '', //약정종료일
            repeatWeek: '', //반복처리요일
            repeatDay: '', //반복처리일자
            insuApplyId: '', //자동청구id
            retroMonth: '', //소급청구기간(0,12,24,36)
        },
        //param으로 쓰일 값들
        auth: {
            korRegId: '', // MMDD + 성별코드
            custName: '', // 이름
            telecomType: '', //통신사 코드
            custHp: '', // 전화번호
            hospitalCode: '', //병원코드
            smsRequestSeq: '', //인증 확인 시 필요
            smsResponseSeq: '', //인증 확인 시 필요
        },
    },
    //api response
    respository: {
        /*IDcardCopy: 신분증사진
        autoAccountExcept
        autoTransfer
        bankbook: 통장사본요구
        cddRequired
        faxEnterAddr: 주소입력
        jobInput: 직업입력
        jobSelect: 직업선택
        notiSelect: 보험청구안내
        pharmPayment: 약제비첨부가능
        rcvInvitations: 안내장수령방법
        repFaxNum : 팩스번호입력
        serviceCenterContact: 팩스번호선택
        * */
        findUiControlVal: null,
        terms: [], //약관 보험사 이후
        authTerms: [], // 인증 약관
        telecomTerms: [], //통신사 약관
        insuCompanys: [], //보험사 연동 목록
        selectCompany: {
            // "id": 2,
            // "homeUrl": "www.kbinsure.co.kr",
            // "logoUrl": "http://",
            // "openedOn": "2017-01-01",
            // "enabled": true,
            // "insuCompType": "I",
            // "claimType": "Y",
            // "insuCompNm": "KB손해보험",
            // "faxNo": "0303-3444-3925",
            // "csPhoneNo": "1544-0114",
            // "insuCompCd": "KBINS",
            // "insuDispNm": "KB손해보험",
            // "ifType": "Y",
            // "dispOrd": null,
            // "lifeYn": "N",
            // "subsEnabled": true
        },
        checkBankAccountNm: {},
        userId: '',
        hospitalNm: '',
        hash: '', // 보안 용도-1
        access_hash: '', //보안 용도-2
        hospitalThumbnail: '', //로고
        androidPackage: '', //안드로이드 설치 패키지
        iOSPackage: '', //iOS 설치 패키지
        possibleHospitals: [], //병원코드 없는 프로세스에서 자동청구 가능한 병원 목록
        myPossibleHospitals: [],
    },
    //ui에 필요한 값
    uiData: {
        groupByPossibleHospitals: [],
        telecomNm: '', //통신사명
        bankNm: '', //지급계좌 은행명
        deptNm: '', //진료과
        minAmtNm: '', //청구 진료비명
        jobCategoryNm: '', //직업 대분류명
        socialNum: '', //주민번호뒷자리
        signBackup: null,
        bankAccountRelNm: '' /*예금주와 피보험자관계 명*/,
        prcMode: 'outer', //inner: 자체프로세스, outer:타병원프로세스
        jobType: null,
        kakaoNotiTreatList: [] /*자동청구 알림톡 진료내역*/,
        kakaoNotiCheck: null /*자동청구 알림톡 신분증하고 진료내역 확인*/,
    },
    //자동청구 알림톡
    web: {},
    webDispData: {},
};

const getters = {
    getWebTalkDispData(state) {
        return state.webDispData;
    },
    getWebTalkPayLoad(state) {
        return state.web;
    },
    getKakaoTreatList(state) {
        return state.uiData.kakaoNotiTreatList;
    },
    getAuthTerms(state) {
        return state.respository.authTerms;
    },
    getPayloadData(state) {
        return state.payload;
    },
    getUiData(state) {
        return state.uiData;
    },
    getRespositData(state) {
        return state.respository;
    },
    getClaimAgreeInfoTersm(state) {
        return state.respository.terms;
    },
    getInsuCompays(state) {
        return state.respository.insuCompanys;
    },
    getSelectCompany(state) {
        return state.respository.selectCompany;
    },
    getBankAccountRelNm(state) {
        return state.uiData.bankAccountRelNm;
    },
    getBankNm(state) {
        return state.uiData.bankNm;
    },
    getSocialNum(state) {
        return state.uiData.socialNum;
    },
    getCheckBankAccountNm(state) {
        return state.respository.checkBankAccountNm;
    },
    getJobType(state) {
        return state.uiData.jobType;
    },
};

import { IDCardType } from '@/component/photo/IDCardType';

const actions = {
    async callSubscriptions({ commit, getters, state }, data) {
        return new Promise(async resolve => {
            let v = null;
            let { insuCompCd, idcardType } = getters['getPayloadData'].reg;
            if (insuCompCd == 'NHLIFE') {
                if (idcardType == IDCardType.IDCard) {
                    state.payload.reg.idcardType = '1';
                } else if (idcardType == IDCardType.DriversLicense) {
                    state.payload.reg.idcardType = '2';
                } else if (idcardType == IDCardType.Passport) {
                    state.payload.reg.idcardType = '3';
                }
            }
            if (getters.getPayloadData.reg.insuApplyId) {
                let { userCi, userNm, hospitalCd, birthday, userIdno2, userTel } = getters['getPayloadData'].reg;
                let param = { userCi, userNm, birthday, userIdno2, userTel };

                if (getters['getUiData'].prcMode == 'inner') {
                    new RestApi(insuRestApi).subscriptionsHospitalsV2
                        .setParam(
                            Object.assign({}, param, {
                                hospitals: getters.getPayloadData.reg.multiSubscrib,
                            }),
                        )
                        .getResponse()
                        .then(v => {
                            if (v) {
                                resolve(v.response);
                            } else {
                                resolve();
                            }
                        })
                        .catch(e => {
                            resolve(e);
                        });
                } else {
                    new RestApi(insuRestApi).subscriptionsHospitals
                        .setParam(
                            Object.assign({}, param, {
                                hospitalCd,
                                agreeId: getters.getPayloadData.reg.agreeId,
                            }),
                        )
                        .getResponse()
                        .then(v => {
                            if (v) {
                                resolve(v.response);
                            } else {
                                resolve();
                            }
                        })
                        .catch(e => {
                            resolve(e);
                        });
                }
            } else {
                if (getters['getUiData'].prcMode == 'inner') {
                    let param = {
                        ...getters.getPayloadData.reg,
                        hospitals: getters.getPayloadData.reg.multiSubscrib,
                    };
                    new RestApi(insuRestApi).multiReceiptClaim
                        .setParam(param)
                        .getResponse()
                        .then(v => {
                            if (v) {
                                resolve(v.response);
                            } else {
                                resolve();
                            }
                        });
                } else {
                    new RestApi(insuRestApi).subscriptions
                        .setParam(getters.getPayloadData.reg)
                        .getResponse()
                        .then(v => {
                            if (v) {
                                resolve(v.response);
                            } else {
                                resolve();
                            }
                        })
                        .catch(e => {
                            resolve(e);
                        });
                }
            }
        });
    },
    async callSubscriptionsConfirm({ commit, getters }, data) {
        return new Promise(async resolve => {
            new RestApi(insuRestApi).subscriptionsConfirm
                .setParam({
                    userCi: getters.getPayloadData.reg.userCi,
                    hospitalCd: getters.getPayloadData.reg.hospitalCd,
                    userIdno: getters.getPayloadData.reg.birthday.slice(2) + getters.getPayloadData.reg.userIdno2,
                })
                .getResponse()
                .then(v => {
                    if (v && v.response) {
                        commit('setConfirmData', v.response);
                    } else {
                        commit('setConfirmData', {});
                    }
                    if (v) {
                        resolve(v.response);
                    } else {
                        resolve();
                    }
                })
                .catch(e => {
                    resolve(e);
                });
        });
    },
    async callFindBankCheck({ commit, dispatch, state }, data) {
        return new Promise(async resolve => {
            new RestApi(insuRestApi).getAccountsConfirm
                .setParam(data)
                .getResponse()
                .then(v => {
                    if (v && v.response) {
                        commit('setBankCheck', v.response);
                    }
                    if (v) {
                        resolve(v.response);
                    } else {
                        resolve();
                    }
                })
                .catch(e => {
                    resolve(e);
                });
        });
    },
    async callClaimAgreeInfoTerms({ commit, getters }, data) {
        return actionsLoadingTemplate(async () => {
            let terms = await new RestApi(insuRestApi).getTerms.setParam(data).getResponse();
            commit('setClaimAgreeInfoTerms', terms.response.content);
        }).catch(e => {
            throw new $ex.UnExpectedResponse(e, '청구의 신- 초간편청구', '약관목록을 가져오지 못했습니다.', null, {
                user: false,
                server: true,
            });
        });
    },
    async callInsuCompany({ commit, getters }, data) {
        return actionsLoadingTemplate(async () => {
            let insuCompanys = await new RestApi(insuRestApi).getAutoInsu
                .setParam({ insuType: 'insu', page: 1, pageSize: 1000 })
                .getResponse();
            insuCompanys = insuCompanys.response;
            commit('setInsuCompanys', insuCompanys);
        }).catch(e => {
            throw new $ex.UnExpectedResponse(e, '청구의 신- 초간편청구', '보험사목록을 가져오지 못했습니다.', null, {
                user: false,
                server: true,
            });
        });
    },
    async callPostUserAuth({ commit, getters }, data) {
        return actionsLoadingTemplate(async () => {
            const { hospitalCd } = getters['getPayloadData'].reg;
            let param = {
                ...getters['getPayloadData'].auth,
                hospitalCode: hospitalCd,
            };
            let res = await new RestApi(insuRestApi).postUserAuth.setParam(param).getResponse();

            commit('setPayLoadAuth', {
                key: 'smsRequestSeq',
                value: res.response.smsRequestSeq,
            });
            commit('setPayLoadAuth', {
                key: 'smsResponseSeq',
                value: res.response.smsResponseSeq,
            });

            return res;
        });
    },
    async asyncAuthConfirm({ commit, getters }, auth) {
        return actionsNormalTemplate(async () => {
            const { smsRequestSeq, smsResponseSeq } = getters['getPayloadData'].auth;
            const { hospitalCd } = getters['getPayloadData'].reg;
            let param = {
                smsRequestSeq: smsRequestSeq,
                smsResponseSeq: smsResponseSeq,
                smsAuthNum: auth.clientSecret,
                hospitalCode: hospitalCd,
            };

            let v = await new RestApi(insuRestApi).postSmsAuth.setParam(param).getResponse();
            let responseEntity = {
                hash: v.response.hash,
                code: v.response.responseCode,
                access_hash: CryptoJS.SHA256(v.response.ci + v.response.responseCode),
            };
            commit('setPayLoadReg', { key: 'userCi', value: v.response.ci });
            commit('setRepository', { key: 'hash', value: responseEntity.hash });
            commit('setRepository', {
                key: 'access_hash',
                value: responseEntity.access_hash,
            });
            return responseEntity;
        });
    },
    callFindUiControlVal({ commit, getters }, data) {
        const { insuCompCd } = getters['getRespositData'].selectCompany;
        new RestApi(insuRestApi).getUiContorl
            .setParam({ compCd: insuCompCd, compType: 'INSU_PHOTO' })
            .getResponse()
            .then(v => {
                commit('setFindUiControlVal', v.response);
            })
            .catch(e => {
                throw new $ex.UnExpectedResponse(
                    e,
                    '청구의 신- 초간편청구',
                    '보험사별 옵션 데이터를 가져오지 못했습니다.',
                    null,
                    { user: false, server: true },
                );
            });
    },
    callAsyncHospitalNm({ commit, getters }, data) {
        new RestApi(insuRestApi).getHospitalNm
            .setParam({ hospitalCd: data })
            .getResponse()
            .then(v => {
                commit('setRepository', {
                    key: 'hospitalNm',
                    value: v.response.hospitalNm,
                });
            })
            .catch(e => {
                throw new $ex.UnExpectedResponse(
                    e,
                    '청구의 신- 초간편청구',
                    '보험사별 옵션 데이터를 가져오지 못했습니다.',
                    null,
                    { user: false, server: true },
                );
            });
    },
    async callSyncHospitalNm({ commit, getters }, data) {
        return actionsNormalTemplate(async () => {
            let v = await new RestApi(insuRestApi).getHospitalNm.setParam({ hospitalCd: data }).getResponse();
            commit('setRepository', {
                key: 'hospitalNm',
                value: v.response.hospitalNm,
            });
            return v.response.hospitalNm;
        }).catch(e => {
            throw new $ex.UnExpectedResponse(
                e,
                '청구의 신- 초간편청구',
                '보험사별 옵션 데이터를 가져오지 못했습니다.',
                null,
                { user: false, server: true },
            );
        });
    },
    callTelecomTerms({ commit, getters }, data) {
        return actionsNormalTemplate(async () => {
            let v = await new RestApi(insuRestApi).getTermsV2.setParam({ type: data }).getResponse();
            commit('setRepository', { key: 'telecomTerms', value: v.response });
        }).catch(e => {
            throw new $ex.UnExpectedResponse(
                e,
                '청구의 신- 초간편청구',
                '보험사별 옵션 데이터를 가져오지 못했습니다.',
                null,
                { user: false, server: true },
            );
        });
    },
    callClaimPossibleHospitals({ commit, getters }, data) {
        return actionsLoadingTemplate(async () => {
            let v = await new RestApi(insuRestApi).getClaimPossibleHospitals.getResponse();
            commit('setRepository', { key: 'possibleHospitals', value: v.response });
            return v.response;
        });
    },
    callHospitalOfInfo({ commit, getters }, data) {
        let { hospitalCd } = getters['getPayloadData'].reg;
        new RestApi(insuRestApi).getHospitalOfInfo
            .setParam({ hospitalCd: hospitalCd })
            .getResponse()
            .then(v => {
                for (const [Key, Value] of Object.entries(v.response)) {
                    commit('setRepository', { key: Key, value: Value });
                }
            });
    },
    callMyHospitalClaimPossible({ commit, getters }, data) {
        return new Promise(async resolve => {
            let { userCi, userNm, birthday, userIdno2, userTel } = getters['getPayloadData'].reg;
            let param = {
                userCi: userCi,
                userNm: userNm,
                birthday: birthday,
                userIdno2: userIdno2,
                userTel: userTel,
            };
            new RestApi(insuRestApi).myHospitalClaimPossible
                .setParam(param)
                .getResponse()
                .then(v => {
                    commit('setRepository', {
                        key: 'myPossibleHospitals',
                        value: v.response.hospitals,
                    });
                    resolve(v.response);
                });
        });
    },
    async callSubscripStatusAndList({ commit, getters }, data) {
        return actionsLoadingTemplate(async () => {
            try {
                let v = await new RestApi(insuRestApi).subscriptionsGet.getResponse();
                if (v.response.subscriptionStatus == 'subscribe') {
                    return v.response;
                } else {
                    return {};
                }
            } catch (e) {
                return {};
            }
        });
    },
    async callInsuJob({ commit, getters }, data) {
        let v = await new RestApi(insuRestApi).getCommonCode.setParam({ codeCls: 'job_cd' }).getResponse();
        commit('setInsuJob', v.response);
    },
    async callSaveIdCard({ commit, dispatch, state }, data) {
        /*알림톡 신분증 저장*/
        return new Promise(async resolve => {
            new RestApi(insuRestApi).postAutoClaimIdCard
                .setParam(data)
                .getResponse()
                .then(v => {
                    resolve(true);
                })
                .catch(e => {
                    resolve(e);
                });
        });
    },
    async callGetTreatList({ commit, dispatch, state }, data) {
        /*알림톡 진료내역 조회*/
        return new Promise(async resolve => {
            new RestApi(insuRestApi).getAutoClaimTreat
                .setParam(data)
                .getResponse()
                .then(v => {
                    commit('setKakaoTreatList', v.response);
                    resolve(v.response);
                })
                .catch(e => {
                    resolve(e);
                });
        });
    },
    async callPostTreatList({ commit, dispatch, state }, data) {
        /*알림톡 진료내역 저장*/
        return new Promise(async resolve => {
            new RestApi(insuRestApi).postAutoClaimTreat
                .setParam(data)
                .getResponse()
                .then(v => {
                    resolve(true);
                })
                .catch(e => {
                    resolve(e);
                });
        });
    },
    async callGetClaimCheck({ commit, dispatch, state }, data) {
        return new Promise(async resolve => {
            new RestApi(insuRestApi).getAutoClaimCheck
                .setParam(data)
                .getResponse()
                .then(v => {
                    commit('setKakaoNotiCheck', v.response);
                    resolve(v.response);
                })
                .catch(e => {
                    resolve(e);
                });
        });
    },
    async callPostTreatListV2({ commit, getters, state }, data) {
        /*자동청구 진료예정목록 저장 , 서명, 동의서, 위임장*/
        return new Promise((resolve, reject) => {
            new RestApi(insuRestApi).postAutoClaimTreatV2
                .setParam(getters.getWebTalkPayLoad)
                .getResponse()
                .then(v => {
                    resolve(v.response);
                })
                .catch(e => {
                    reject(e);
                });
        });
    },
    async callPostImgOcr({ commit, getters }, data) {
        return actionsNormalTemplate(async () => {
            return new Promise(async resolve => {
                new RestApi(insuRestApi).postImgOCR
                    .setParam(data)
                    .getResponse()
                    .then(v => {
                        resolve(v.response);
                    })
                    .catch(e => {
                        resolve(e);
                    });
            });
        });
    },
};

const mutations = {
    setWebTalkData(state, data) {
        state.web[data.type] = data.value;
    },
    setWebTalkDispData(state, data) {
        state.webDispData[data.type] = data.value;
    },
    setKakaoNotiCheck(state, data) {
        state.uiData.kakaoNotiCheck = data;
    },
    setKakaoTreatList(state, data) {
        state.uiData.kakaoNotiTreatList = data;
    },
    setAuthTerms(state, data) {
        state.respository.authTerms = data;
    },
    setStoreInit(state, data) {
        let keyObj = Object.keys(state);
        $.each(keyObj, function(index, item) {
            if (item == 'payload') {
                let obj = Object.keys(state[item]);
                $.each(obj, function(index, itm) {
                    let v = Object.keys(state[item][itm]);
                    typeCheck(v, state[item][itm]);
                });
            } else {
                let v = Object.keys(state[item]);
                typeCheck(v, state[item]);
            }
        });
        function typeCheck(v, setValue) {
            $.each(v, function(index, im) {
                if (im === 'retroMonth') {
                    setValue[im] = '';
                    return false;
                }
                if (exceptionKey(im)) {
                    let datatype = $.type(setValue[im]);
                    if (datatype == 'number') setValue[im] = 0;
                    else if (datatype == 'string') setValue[im] = '';
                    else if (datatype == 'boolean') setValue[im] = false;
                    else if (datatype == 'array') setValue[im] = [];
                    else if (datatype == 'object') setValue[im] = {};
                }
            });
        }
        function exceptionKey(item) {
            let arr = [
                'multiSubscrib',
                'userCi',
                'termsIds',
                'optTerms',
                'userTel',
                'userIdno2',
                'sex',
                'birthday',
                'userNm',
                'hospitalCd',
                'applyOrg',
                'hospitalNm',
                'socialNum',
                'hash',
                'access_hash',
                'prcMode',
            ];
            if (arr.includes(item)) {
                return false;
            } else {
                return true;
            }
        }
    },
    setFindUiControlVal(state, data) {
        let obj = new Object();
        $.each(data, function(index, val) {
            obj[val.ctrlKey] = JSON.parse(val.ctrlVal);
        });
        state.respository.findUiControlVal = obj;
    },
    setSelectCompany(state, data) {
        state.respository.selectCompany = data;
    },
    getInsuList(state, data) {
        state.getData.fire = data;
    },
    setClaimAgreeInfoTerms(state, data) {
        state.respository.terms = data;
    },
    signImgChange(state, data) {
        state.payload.signImg = data;
    },
    setInsuCompanys(state, data) {
        state.respository.insuCompanys = data;
    },
    setTelecomNm(state, data) {
        state.uiData.telecomNm = data;
    },
    setLicense(state, data) {
        switch (data.type) {
            case 'ic':
                state.payload.reg.idcardIssueOrg = data.license1;
                state.payload.reg.idcardIssueDate = data.license2;
                state.payload.reg.regNo = '';
                state.payload.reg.checkCd = '';
                break;
            case 'dl':
                state.payload.reg.regNo = data.license1;
                state.payload.reg.checkCd = data.license2;
                state.payload.reg.idcardIssueOrg = '';
                state.payload.reg.idcardIssueDate = '';
                break;
            case 'pp':
                state.payload.reg.regNo = data.license1;
                state.payload.reg.idcardIssueDate = data.license2;
                state.payload.reg.idcardIssueOrg = '';
                state.payload.reg.checkCd = '';
                break;
        }
        return (state.payload.reg.idcardType = data.type);
    },
    setBankCheck(state, data) {
        state.respository.checkBankAccountNm = data;
    },
    setConfirmData(state, data) {
        let $payload = state.payload.reg;
        let $respository = state.respository;
        Object.keys(data).forEach(key => {
            if (key === 'userId') {
                $respository[key] = data[key];
            } else if (key === 'userCi') {
            } else {
                $payload[key] = data[key];
            }
        });
        state.payload.reg = $payload;
        state.respository = $respository;
        console.log(state.payload);
    },
    setPayLoadAuth(state, obj) {
        state.payload.auth[obj.key] = obj.value;
    },
    setPayLoadReg(state, obj) {
        state.payload.reg[obj.key] = obj.value;
    },
    setRepository(state, obj) {
        if (obj.key == 'myPossibleHospitals') {
            obj.value = obj.value.sort(ascending);
        }
        state.respository[obj.key] = obj.value;
        function ascending(a, b) {
            return a.hospitalNm < b.hospitalNm ? -1 : a.hospitalNm == b.hospitalNm ? 0 : 1;
        }
    },
    setUidata(state, obj) {
        state.uiData[obj.key] = obj.value;
    },
    setInsuJob(state, data) {
        state.uiData.jobType = data;
    },
};

export const autoClaim = {
    state,
    actions,
    getters,
    mutations,
};
